// Trasy APP. Start = „Pulpit” (właściciel 18.10). Stare skróty z ekranu telefonu (`/?view=devices` z manifestu
// starej APP) prowadzą do nowych ekranów - po przełączeniu app.termometrwifi.pl przypięte skróty działają dalej.
import { Suspense, useEffect } from "react";
import { Navigate, Route, Routes, useNavigate, useSearchParams } from "react-router";
import { useSesja } from "./sesja";
import { t } from "./i18n/t";
import {
  Alarmy, Asystent, DodajUrzadzenie, Energia, FormularzPrzepisu, Instrukcje, Logowanie, Osiagniecia, Plany, Przepisy, Pulpit, SzczegolyPrzepisu,
  Pulpity, Serwis, SerwisSprzetu, Statystyki,
  Udostepnianie, Urzadzenia, Ustawienia,
  doladujWTle,
} from "./ekrany/ladowanie";
import { odswiezPush } from "./api/powiadomienia";
import { PowlokaAplikacji } from "./PowlokaAplikacji";
import { skrotyAplikacji } from "./uklad/instalacja";
import { EkranAktualizacji, potwierdzStart, useAktualizacja } from "./uklad/Aktualizacja";
import { Blad, Ladowanie } from "./uklad/Stany";
import { useBlokada } from "./uklad/blokada";
import { EkranBlokady } from "./uklad/EkranBlokady";

const STARE_WIDOKI: Record<string, string> = { devices: "/urzadzenia", settings: "/ustawienia", service: "/serwis",
  instrukcje: "/instrukcje", achievements: "/osiagniecia" };

function Start() {
  const [p] = useSearchParams();
  // Push i e-mail starej APP: `?view=rma&t={id}` - zgłoszenie serwisowe.
  if (p.get("view") === "rma") return <Navigate to={"/serwis-sprzetu" + (p.get("t") ? "/" + p.get("t") : "")} replace />;
  const stary = STARE_WIDOKI[p.get("view") ?? ""];
  return stary ? <Navigate to={stary} replace /> : <Pulpity />;
}

function EkranStartu() {
  return <div className="iot-app iot-start"><Ladowanie /></div>;
}

function BladStartu({ ponow }: { ponow: () => void }) {
  return (
    <div className="iot-app iot-start">
      <Blad tytul={t("Brak połączenia z serwerem")} opis={t("Sprawdź internet i spróbuj ponownie.")} onPonow={ponow} zglos={false} />
    </div>
  );
}

export function Aplikacja() {
  const { sesja, sprawdz } = useSesja();
  const zalogowany = sesja.stan === "jest";
  const idz = useNavigate();
  const aktualizacja = useAktualizacja();
  const blokada = useBlokada();
  useEffect(potwierdzStart, []); // paczka APP w aplikacji ze sklepu wystartowała (inaczej wtyczka ją cofa)
  useEffect(() => {
    if (!zalogowany) return;
    doladujWTle();
    void odswiezPush(); // subskrypcja tego telefonu na koncie aktualna (usługa push mogła ją zmienić)
    return skrotyAplikacji((adres) => void idz(adres), t); // aplikacja ze sklepu: skróty z ikony
  }, [zalogowany, idz]);
  if (aktualizacja === "wymagana") return <EkranAktualizacji />; // aplikacja ze sklepu poniżej minimalnej wersji
  // Blokada PIN-em (aplikacja ze sklepu, gdy klient ją włączył) - przed ekranami, także przed sprawdzeniem sesji.
  if (blokada === "sprawdzam") return <EkranStartu />;
  if (blokada === "zablokowana" && zalogowany) return <EkranBlokady />;
  switch (sesja.stan) {
    case "sprawdzam":
      return <EkranStartu />;
    case "blad":
      return <BladStartu ponow={sprawdz} />;
    case "brak":
      return (
        <Suspense fallback={<EkranStartu />}>
          <Logowanie />
        </Suspense>
      );
  }
  return (
    <Routes>
      <Route element={<PowlokaAplikacji />}>
        <Route path="/" element={<Start />} />
        <Route path="/pulpit/:id" element={<Pulpity />} />
        <Route path="/pulpit/urzadzenie/:sn" element={<Pulpit />} />
        <Route path="/pulpit/klienta/:id" element={<Pulpity />} />
        <Route path="/urzadzenia" element={<Urzadzenia />} />
        <Route path="/urzadzenia/dodaj" element={<DodajUrzadzenie />} />
        <Route path="/urzadzenia/:sn" element={<Pulpit />} />
        <Route path="/udostepnianie" element={<Udostepnianie />} />
        <Route path="/serwis" element={<Serwis />} />
        <Route path="/serwis/ekran/:ekran" element={<Serwis />} />
        <Route path="/statystyki" element={<Statystyki />} />
        <Route path="/statystyki/:sn" element={<Statystyki />} />
        <Route path="/energia" element={<Energia />} />
        <Route path="/ustawienia" element={<Ustawienia />} />
        <Route path="/ustawienia/:sekcja" element={<Ustawienia />} />
        <Route path="/alarmy" element={<Alarmy />} />
        <Route path="/asystent" element={<Asystent />} />
        <Route path="/alarmy/:id" element={<Alarmy />} />
        <Route path="/przepisy" element={<Przepisy />} />
        <Route path="/przepisy/nowy" element={<FormularzPrzepisu />} />
        <Route path="/przepisy/:id" element={<SzczegolyPrzepisu />} />
        <Route path="/przepisy/:id/edycja" element={<FormularzPrzepisu />} />
        <Route path="/plany" element={<Plany />} />
        <Route path="/instrukcje" element={<Instrukcje />} />
        <Route path="/instrukcje/:id" element={<Instrukcje />} />
        <Route path="/osiagniecia" element={<Osiagniecia />} />
        <Route path="/serwis-sprzetu" element={<SerwisSprzetu />} />
        <Route path="/serwis-sprzetu/:id" element={<SerwisSprzetu />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
